/* eslint-disable eqeqeq */
import { FC, useEffect, useState } from "react";
import { Box } from "../../../../../components/box";
import { Form, Row, Col, Select } from "antd";
import { EditableTable } from "./EditableTable.tsx/Table";
import { listFields } from "../constant/field-names";
import { RenderHelper } from "../utils/render-helper";
import {
  StyledTitle,
} from "../../../../../components/styled-antd";
import { useSelector } from "../../../../../store/store";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-employee-request.service";
import { useRouteMatch } from "react-router-dom";
import { requestStatus } from "../../../../../constants";
import { getInforRegistrationCourse, isHideApproveButton } from "../utils";
import { CreateNotification } from "../../../../../components/notifier";
import { PATH } from "../constant";
import { useHistory } from "react-router-dom";
import { approveRequestEmail } from "../utils/send-mail";
import { MAIL_TEMPLATE_LIST_TRAINEE } from "../constant";
import { filterEmployeesByDepartment } from "../../summary-registration-courses/utils";
import { department } from "../../../info-technology-process/data";
import { AlternateApproverSelect } from "../../../../../components";
import _ from "lodash";

export const ExportList: FC<{
  eRequests: any;
  setERequests: any;
  hiddenEdit?: boolean;
}> = ({ eRequests }) => {
  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );

  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );

  const [pickedUser, setPickedUser] = useState("");

  const [subERequest, setSubERequest] = useState<any[]>([]);
  const history = useHistory();

  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();

  const { id } = useRouteMatch().params as any;
  const [detail, setDetail] = useState<any>();

  const loadData = async () => {
    const detail =
      await HOSummaryEmployeeRequestService.getDetailsSummaryEmployeeRequest(
        id
      );

    try {
      const newERequests = detail?.fields?.eContent
        ? JSON.parse(detail.fields.eContent)
        : [];

      const search = window.location.search;
      const params = new URLSearchParams(search);
      const fromEmail = params.get("fromEmail");

      if (fromEmail == "1") {
        const eDepartment = params.get("eDepartment");

        const value = department.filter(
          (value1: any) =>
            value1.id == eDepartment || eDepartment?.includes(value1.id)
        );

        if (value) {
          const newSubERequests = newERequests.filter(
            (value1: any) => value1.unit === value[0].value
          );

          form.setFieldValue("eDepartment", value[0].value);
          form.setFieldValue(
            "eApprovedBy",
            getInforRegistrationCourse(detail, currentUserName, value[0].value)
              .approver
          );

          setSubERequest(newSubERequests);
        }
      } else {
        const newSubERequests = newERequests.filter(
          (value: any) => value.unit === "Phòng Công nghệ thông tin"
        );

        setSubERequest(newSubERequests);
        form.setFieldValue(
          "eApprovedBy",
          getInforRegistrationCourse(
            detail,
            currentUserName,
            "Phòng Công nghệ thông tin"
          ).approver
        );
      }
    } catch (error) {
      console.log({ err: "error" });
    }

    setDetail(detail);
  };

  const onFinish = async () => {
    const newERequests = _.cloneDeep(eRequests).filter(
      (value: any) => value.unit != form.getFieldValue("eDepartment")
    );

    if (subERequest.length == 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng thêm học viên vào phiếu`,
        icon: "/icons/error.png",
      });

      return;
    }

    for (const request of subERequest) {
      newERequests.push({ ...request });
    }

    // let initFields = {
    //   eContent: JSON.stringify(newERequests),
    //   eSubRequestsStatus: detail.fields?.eSubRequestsStatus
    //     ? JSON.stringify({
    //         ...JSON.parse(detail.fields?.eSubRequestsStatus),
    //         [form.getFieldValue("eDepartment")]: {
    //           status: requestStatus.submitted,
    //           approver: pickedUser
    //             ? pickedUser
    //             : form.getFieldValue("eApprovedBy"),
    //           createdEmail: user.current.username,
    //           createdName: user.current.name,
    //         },
    //       })
    //     : JSON.stringify({
    //         [form.getFieldValue("eDepartment")]: {
    //           status: requestStatus.submitted,
    //           approver: pickedUser
    //             ? pickedUser
    //             : form.getFieldValue("eApprovedBy"),
    //           createdEmail: user.current.username,
    //           createdName: user.current.name,
    //         },
    //       }),
    // };

    try {
      // const resp =
      //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
      //     id,
      //     initFields
      //   );

      if (
        !(
          getInforRegistrationCourse(
            detail,
            currentUserName,
            form.getFieldValue("eDepartment")
          ).status == requestStatus.submitted
        )
      ) {
        await approveRequestEmail(
          detail,
          MAIL_TEMPLATE_LIST_TRAINEE.approve,
          pickedUser ? pickedUser : form.getFieldValue("eApprovedBy"),
          mailtemplates,
          form.getFieldValue("eDepartment")
        );

        CreateNotification({
          title: "Thành công",
          body: `Tạo danh sách học viên thành công`,
          icon: "/icons/success.png",
        });
      } else {
        CreateNotification({
          title: "Thành công",
          body: `Cập nhật danh sách học viên thành công`,
          icon: "/icons/success.png",
        });
      }

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Tạo danh sách học viên thất bại`,
        icon: "/icons/error.png",
      });

      history.push(PATH.HOME);
    }
  };

  const [form] = Form.useForm();

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      const newSubERequests = eRequests.filter(
        (value: any) => value.unit === changedValues.eDepartment
      );

      setSubERequest(newSubERequests);
    }

    if (!changedValues.eApprovedBy) {
      if (
        getInforRegistrationCourse(
          detail,
          currentUserName,
          form.getFieldValue("eDepartment")
        ).approver
      ) {
        form.setFieldValue(
          "eApprovedBy",
          getInforRegistrationCourse(
            detail,
            currentUserName,
            form.getFieldValue("eDepartment")
          ).approver
        );
      } else {
        form.setFieldValue("eApprovedBy", null);
      }
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (detail?.fields?.eRequestStatus == requestStatus.rejected)
    return (
      <Box title="Chi tiết">
        <div className="d-flex justify-content-center text-secondary my-3">
          Phiếu đã bị từ chối
        </div>
      </Box>
    );

  if (detail?.fields?.eRequestStatus != requestStatus.completed)
    return (
      <Box title="Chi tiết">
        <div className="d-flex justify-content-center text-secondary my-3">
          Phiếu đang chờ phê duyệt
        </div>
      </Box>
    );

  function onFinishFailed({ errorFields }: any) {
    CreateNotification({
      title: "Thất bại",
      body: `${
        errorFields?.[0].errors?.[0] || "Tạo danh sách học viên thất bại"
      }`,
      icon: "/icons/error.png",
    });
  }

  return (
    <Box title="Chi tiết">
      <Form
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Row gutter={[32, 0]}>
          <RenderHelper fields={listFields} />

          {!isHideApproveButton(
            getInforRegistrationCourse(
              detail,
              currentUserName,
              form.getFieldValue("eDepartment")
            ).status
          ) && (
            <Col span={12}>
              <StyledTitle level={5}>
                Người duyệt{" "}
                {!pickedUser && <span className="text-danger">(*)</span>}
              </StyledTitle>
              <Form.Item
                name="eApprovedBy"
                rules={[{ required: !pickedUser, message: "Chọn người duyệt" }]}
              >
                <Select
                  disabled={
                    getInforRegistrationCourse(
                      detail,
                      currentUserName,
                      form.getFieldValue("eDepartment")
                    ).isApprover
                  }
                  options={filterEmployeesByDepartment(
                    department,
                    employees,
                    form.getFieldValue("eDepartment")
                  )}
                  placeholder="Thủ trưởng CQ/ĐV"
                />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <ApprovalStatus
              status={
                getInforRegistrationCourse(
                  detail,
                  currentUserName,
                  form.getFieldValue("eDepartment")
                ).status
              }
            />
          </Col>
          {!isHideApproveButton(
            getInforRegistrationCourse(
              detail,
              currentUserName,
              form.getFieldValue("eDepartment")
            ).status
          ) && (
            <Col span={12}>
              <StyledTitle level={5}>Người duyệt thay thế</StyledTitle>
              <AlternateApproverSelect
                placeholder="Thủ trưởng CQ/ĐV"
                onChange={(value) => {
                  if (value) {
                    setPickedUser(value);
                  } else {
                    setPickedUser("");
                  }
                }}
              />
            </Col>
          )}
        </Row>
        <div style={{ overflowX: "scroll" }}>
          <EditableTable
            detail={detail}
            eRequests={subERequest}
            setERequests={setSubERequest}
            form={form}
          />
        </div>
      </Form>
    </Box>
  );
};

const ApprovalStatus = ({ status }: { status: string }) => {
  if (status === requestStatus.submitted) {
    return (
      <div className="d-flex">
        <StyledTitle level={5}>Trạng thái: </StyledTitle>
        <div className="font-weight-bold text-warning ml-1">Đang đợi duyệt</div>
      </div>
    );
  }

  if (status === requestStatus.completed)
    return (
      <div className="d-flex">
        <StyledTitle level={5}>Trạng thái: </StyledTitle> {""}
        <div className="font-weight-bold text-success ml-1">Đã hoàn tất</div>
      </div>
    );

  if (status === requestStatus.rejected)
    return (
      <div className="d-flex">
        <StyledTitle level={5}>Trạng thái: </StyledTitle>

        <div className="font-weight-bold text-danger ml-1">Đã bị từ chối</div>
      </div>
    );

  return (
    <div className="d-flex">
      <StyledTitle level={5}>Trạng thái: </StyledTitle>

      <div className="font-weight-bold text-warning ml-1">Chưa được gửi</div>
    </div>
  );
};
